<div class="company-paymethods">
  <div class="company-paymethods-general">
    <div class="company-paymethods-form" *ngIf="!isEditingInfo">
      <div class="company-paymethods-section-title">
        {{ "company.paymethods.choose_paymentmethod" | translate }}
      </div>

      <div class="company-paymethods-container-check">
        <cowing-checkbox
          [isForm]="false"
          [label]="'Cuenta bancaria'"
          (event)="toggleForm()"
          [value]="showBankInfoForm"
        ></cowing-checkbox>
        <cowing-checkbox
          [isForm]="false"
          [label]="'Tarjeta'"
          (event)="toggleForm()"
          [value]="!showBankInfoForm"
        ></cowing-checkbox>
      </div>
    </div>
    <div
      *ngIf="showBankInfoForm"
      class="company-paymethods-showform"
      [formGroup]="form"
    >
      <div class="company-paymethods-container">
        <div class="company-paymethods-section-title">
          {{ "company.paymethods.add_info" | translate }}
        </div>
        <div class="company-paymethods-section-subtitle">
          {{ "company.paymethods.add_info_description" | translate }}
        </div>
      </div>
      <div class="company-paymethods-container">
        <div class="company-paymethods-section-title">
          {{ "company.paymethods.your_account" | translate }}
        </div>

        <div class="company-paymethods-section">
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'coworking.bank-info.holder' | translate"
            [control]="form.get('holderId')"
          >
          </cowing-input>
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'coworking.bank-info.swift' | translate"
            [control]="form.get('swift')"
          >
          </cowing-input>
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'coworking.bank-info.iban' | translate"
            [control]="form.get('IBAN')"
          >
          </cowing-input>
        </div>
      </div>

      <div class="company-paymethods-container">
        <div class="company-paymethods-section-title">
          {{ "company.paymethods.address" | translate }}
        </div>

        <div class="company-paymethods-section">
          <cowing-input-location
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'coworking.general.address' | translate"
            [control]="form.get('address')"
            (setLocation)="setLocation($event)"
          >
          </cowing-input-location>
        </div>
      </div>
    </div>
    <div
      *ngIf="!showBankInfoForm"
      class="company-paymethods-showform"
      [formGroup]="secondForm"
    >
      <div class="company-paymethods-container">
        <div class="company-paymethods-section-title">
          {{ "company.paymethods.add_card" | translate }}
        </div>

        <div class="company-paymethods-section">
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'company.paymethods.owner' | translate"
            [control]="secondForm.get('owner')"
          >
          </cowing-input>
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'company.paymethods.card-number' | translate"
            [control]="secondForm.get('cardNumber')"
            [type]="'number'"
          >
          </cowing-input>
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'company.paymethods.expire-date' | translate"
            [control]="secondForm.get('expireDate')"
            [type]="'month'"
            [label]="'company.paymethods.expire-date' | translate"
          >
          </cowing-input>
          <cowing-input
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [placeholder]="'company.paymethods.CVV' | translate"
            [control]="secondForm.get('cvv')"
            [type]="'number'"
          >
          </cowing-input>
        </div>
      </div>
    </div>
    <span *ngIf="isEditingInfo">
      {{ "company.paymethods.disclaimer-bank-info" | translate }}</span
    >
    <div *ngIf="isEditingInfo" class="actions-footer">
      <cowing-button
        [label]="'general.close' | translate"
        [type]="EButtonType.RoundedSecondary"
        [iconShow]="false"
        (event)="goBack()"
      >
      </cowing-button>
    </div>
  </div>
</div>
